import { createApp } from 'vue';
import 'core-js/stable';
import 'regenerator-runtime';
import CareerFairSearchForm from '@component_path/search-contents/career_fair/search-form';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('career-fair-search-form');
  const props = JSON.parse(node.getAttribute('data'));

  createApp(CareerFairSearchForm, props).mount('#career-fair-search-form');
});
